import $ from 'jquery';
import plugin from '@core/plugins/lib';
import {mustache} from '@core/plugins/lib/strings';

const ELEMENT_SELECTOR = '[data-product-category-additional-features]';
const PRODCUT_ELEMENT_SELECTOR = '[data-category-and-product-selector-product]';
const FEATURE_ELEMENT_SELECTOR = '[data-product-category-additional-features-wrapper]';
const ADDITIONAL_CONTENT_ELEMENT_SELECTOR = '[data-product-category-additional-features-additional-item-content]';
const TOGGLE_ELEMENT_SELECTOR = '[data-product-category-additional-features-toggle-element]';
const SELECTED_VALUES_ATTR = 'data-selected-values';
const ATTRIBUTES_ATTR = 'data-attributes';
const ELEMENT_ATTR = 'data-product-category-additional-features';
const ITEM_TEMPLATE_SELECTOR = '#productAdditionalFeaturesTemplate';
const CLASSNAME = "input-hidden";
const PLUGIN_NAME = 'ProductAdditionalFeatures';

class ProductAdditionalFeatures {
	constructor(element, options) {
        this.element = element;
		this.options = options;
		this.$element = $(element);
        this.$featuresElement = this.$element.find(FEATURE_ELEMENT_SELECTOR);
        this.$toggleElement = this.$element.find(TOGGLE_ELEMENT_SELECTOR);
        this.selectedVals = this.$element.attr(SELECTED_VALUES_ATTR);
        this.selectedValsList = typeof(this.selectedVals) !== 'undefined' && this.selectedVals.length > 0 ?  JSON.parse(this.selectedVals) : new Array();
        this.attributes = this.$element.attr(ATTRIBUTES_ATTR);
        this.fieldId = this.$element.attr(ELEMENT_ATTR);
        this.itemTemplate = $(ITEM_TEMPLATE_SELECTOR).text();
        this.watch();
    }

    getSelectedProduct() {
        return this.$productElement.val();
    }

    getAdditionalFeatures() {
        var mod = this;        
        var url = "/Umbraco/Api/GetProducts/GetAdditionalFeatures";
        $.ajax({
			url,
			method: 'get',
			success: result => {
                mod.loadFeatures(result);
			},
			error: e => {
			}
		}).done(() => {
            
		});
    }

    getChecked(featureStr) {
        var selected= '';
        $.each(this.selectedValsList, function(k, selectedVal) {
            if (featureStr == selectedVal) {
                selected = "checked=checked";
            }
        });

        return selected;
    }

    loadFeatures(data) {
        var mod = this;
        var product = this.getSelectedProduct();     
        var hideProducts = true;
        var $additionalContentElement = this.$featuresElement.find(ADDITIONAL_CONTENT_ELEMENT_SELECTOR);
        var $additionalContent = typeof($additionalContentElement) !== 'undefined' ? $additionalContentElement.detach() : '';
        
        this.$featuresElement.empty();

        if (data.length > 0) {
            $.each(data, function(i, feature) {
                if (feature.ProductId == product) {
                    $.each(feature.AdditionalFeatures, function(j, featureStr) {
                        hideProducts = false;

                        var selected= mod.getChecked(featureStr);
                        var id = mod.fieldId + '_' + j;
                        var html = mustache(mod.itemTemplate, {
                            Name:mod.fieldId,
                            Value:featureStr,
                            Id:id,
                            Attributes:mod.attributes,
                            Selected: selected
                        });
                    
                        mod.$featuresElement.append(html);
                    });
                }
            });

            if (typeof($additionalContent) !== 'undefined' && $additionalContent.length > 0) {
                mod.$featuresElement.append($additionalContent);
            }
        }

        this.toggleElementVisibility(hideProducts);
    }

    toggleElementVisibility(hide) {
        if (hide) {
            this.$element.addClass(CLASSNAME);
            this.$toggleElement.addClass(CLASSNAME);
        }
        else {
            this.$element.removeClass(CLASSNAME);            
            this.$toggleElement.removeClass(CLASSNAME);
        }
    }
    
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
            c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    watch() {
        var mod = this;
        $(document).on('product-selected', function() {            
            mod.$productElement = $(PRODCUT_ELEMENT_SELECTOR);
            mod.getAdditionalFeatures();
        });
    }
}

ProductAdditionalFeatures.DEFAULTS = {};

plugin(PLUGIN_NAME, ProductAdditionalFeatures);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});




// WEBPACK FOOTER //
// ./client/src/core/components/forms/product-additional-features.js